/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Edit_Fund_Visibility_DescriptionInputs */

const en_cas_edit_fund_visibility_description = /** @type {(inputs: Cas_Edit_Fund_Visibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure template and portal visibility`)
};

/**
* | output |
* | --- |
* | "Configure template and portal visibility" |
*
* @param {Cas_Edit_Fund_Visibility_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_edit_fund_visibility_description = /** @type {((inputs?: Cas_Edit_Fund_Visibility_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Edit_Fund_Visibility_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_edit_fund_visibility_description(inputs)
});